import {PAY_PER_USE_HIDDEN_OPERATIONS} from '../constants/PAY_PER_USE_HIDDEN_OPERATIONS';
import {getOperationTypeKey} from './getOperationTypeKey';

interface OperationTypeIdentity {
  resource: string;
  action: string;
}

/** True when a pair is excluded from the UI (no card/column, never summed). */
export const isHiddenOperation = (operation: OperationTypeIdentity): boolean =>
  PAY_PER_USE_HIDDEN_OPERATIONS.includes(getOperationTypeKey(operation));
